"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraOffState = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CameraOffStateStyled = require("./CameraOffState.styled.js");
var _Avatar = require("../Avatar");
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _BrandContext = _interopRequireDefault(require("../../contexts/BrandContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CameraOffState = exports.CameraOffState = function CameraOffState(props) {
  var isStage = props.isStage,
    user = props.user,
    height = props.height,
    width = props.width,
    style = props.style;
  var brandContext = (0, _react.useContext)(_BrandContext["default"]);
  return _react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: brandContext ? brandContext : {}
  }, _react["default"].createElement(_CameraOffStateStyled.BrandedAvatarContainer, {
    height: height,
    width: width,
    "data-testid": "branded-avatar-container",
    style: style
  }, _react["default"].createElement(_CameraOffStateStyled.BlurBackgroundDiv, {
    user: user,
    height: height,
    width: width,
    "data-testid": "cameraoff-blur-background"
  }), _react["default"].createElement(_Avatar.BrandedAvatar, {
    isStage: isStage,
    user: user,
    height: height,
    width: width
  })));
};
CameraOffState.propTypes = {
  isStage: _propTypes.PropTypes["boolean"],
  user: _propTypes.PropTypes.object.isRequired,
  height: _propTypes.PropTypes.string.isRequired,
  width: _propTypes.PropTypes.string.isRequired,
  style: _propTypes.PropTypes.object
};